import { useState, useEffect } from "react";
import { useNavigate, useMatch } from "react-router-dom";

import useSettingsView from "./Views";
import useSettingsCreate from "./Create";

const useSettings = () => {
  const navigation = useNavigate();
  const [headerKey, setHeaderKey] = useState("/configuracion/settings");

  const handleBack = () => {
    navigation(-1);
  };

  const header = {
    "/configuracion/settings": ["Configuración", "Settings"],
    "/configuracion/settings/creacion": ["Configuración", "Settings", "Crear Setting"],
    "/configuracion/settings/editar/:id": ["Configuración", "Settings", "Edición de Setting"],
  };

  const matchSettings = useMatch("/configuracion/settings");
  const matchCreate = useMatch("/configuracion/settings/creacion");
  const matchEdit = useMatch("/configuracion/settings/editar/:id");

  const matches = {
    "/configuracion/settings": matchSettings,
    "/configuracion/settings/creacion": matchCreate,
    "/configuracion/settings/editar/:id": matchEdit,
  };

  useEffect(() => {
    const matchedKey = Object.keys(matches).find((pathname) => matches[pathname]?.pathname === pathname) || "/configuracion/settings";
    setHeaderKey(matchedKey);
  }, [matches]);

  return {
    handleBack,
    header,
    useSettingsView,
    useSettingsCreate,
    setHeaderKey,
    headerKey,
  };
};

export default useSettings;
